import { render, staticRenderFns } from "./detail_Library.vue?vue&type=template&id=97fe9776&scoped=true&"
import script from "./detail_Library.vue?vue&type=script&lang=js&"
export * from "./detail_Library.vue?vue&type=script&lang=js&"
import style0 from "./detail_Library.vue?vue&type=style&index=0&id=97fe9776&scoped=true&lang=css&"
import style1 from "./detail_Library.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fe9776",
  null
  
)

export default component.exports